import { render, staticRenderFns } from "./UserListHeader.vue?vue&type=template&id=53c64244&scoped=true"
import script from "./UserListHeader.vue?vue&type=script&lang=ts"
export * from "./UserListHeader.vue?vue&type=script&lang=ts"
import style0 from "./UserListHeader.vue?vue&type=style&index=0&id=53c64244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c64244",
  null
  
)

export default component.exports